import { Tag, Typography } from '@omnipresentgroup/design-system';

const APPROVED_STATUS = 'Approved';
const PENDING_STATUS = 'Pending approval';

type Props = {
  approved: boolean | null;
};

export const InvoiceReportStatus = ({ approved }: Props) =>
  approved === null ? (
    <Typography as="span" size="14">
      -
    </Typography>
  ) : (
    <Tag id="inv-status" size="small" intent={approved ? 'success' : 'default'}>
      {approved ? APPROVED_STATUS : PENDING_STATUS}
    </Tag>
  );
